import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CHAT_WIDGET_EVENT_CHAT = 'CHAT_WIDGET_EVENT_CHAT';
var CHAT_WIDGET_EVENT_MENU = 'CHAT_WIDGET_EVENT_MENU';
var createWidgetEvent = function createWidgetEvent(type, detail) {
  return new CustomEvent(type === 'menu' ? CHAT_WIDGET_EVENT_MENU : CHAT_WIDGET_EVENT_CHAT, {
    detail: detail
  });
};
var generateHandler = function generateHandler(type) {
  return function (flag, options) {
    var event = createWidgetEvent(type, _objectSpread({
      flag: flag
    }, options || {}));
    window.dispatchEvent(event);
  };
};
export var setChatWidgetOpen = generateHandler('chat');
export var setChatWidgetMenuOpen = generateHandler('menu');